import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { StorageService } from "../storage/storage.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FIREBASE_COLLECTIONS } from "src/app/enums/types.enum";

@Injectable({
  providedIn: "root",
})
export class FacilityService {
  private API_URL = environment.API_URL;

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
    private firestore: AngularFirestore
  ) {}

  private getToken() {
    let data = this.storageService.get("auth");
    const headers = {
      Authorization: `Bearer ${data?.token}`, // Replace `token` with your actual bearer token
    };
    return headers;
  }

  getAllFacilities(params: any) {
    return this.firestore
      .collection(FIREBASE_COLLECTIONS.SPORTS_FACILITIES)
      .valueChanges();
  }

  getFacility(id: string) {
    return this.firestore
      .doc(`${FIREBASE_COLLECTIONS.SPORTS_FACILITIES}/${id}`)
      .valueChanges();
  }
  
  getFacilityWithValue(id: any) {
    this.firestore
      .doc(id)
      .valueChanges()
      .subscribe({
        next: (res) => {
          return res;
        },
      });
  }

  getSlotsOfCourt(courtId: number | string) {
    const headers = this.getToken();
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.API_URL}/slot/court/${courtId}`, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }
}
